import Login from "../../components/login/login";

export default function LoginPage(){
    return <Login />;
}